import { render, staticRenderFns } from "./CTHeader.vue?vue&type=template&id=be2b8f88&scoped=true"
import script from "./CTHeader.vue?vue&type=script&lang=js"
export * from "./CTHeader.vue?vue&type=script&lang=js"
import style0 from "./CTHeader.vue?vue&type=style&index=0&id=be2b8f88&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2b8f88",
  null
  
)

export default component.exports